/**
 * True while LinkPass is handing the customer back, before the exchange has finished.
 *
 * Read straight from the browser's url rather than from the router's, because the app has
 * only just booted and the router has not settled yet. Callers use this to hold still: the
 * page they are on is mid-sign-in, not freshly arrived.
 *
 * A leaf module on purpose: the payment page reads it on every visit, and it must not drag
 * Auth0 into the main bundle — everything else v3 loads lazily with the v3 form.
 */
export const isLinkPayAuthReturning = (): boolean => {
	const params = new URLSearchParams(globalThis.location?.search ?? "");

	// code+state on success, error+state on a cancel or refusal — both are LinkPass handing
	// the customer back, and both need the page to hold still rather than bounce to the cart.
	return params.has("state") && (params.has("code") || params.has("error"));
};
